export default __webpack_public_path__ + "static/media/filter-status-close.137ba29a.svg";